module.exports = __webpack_public_path__ + "static/media/ghbank-bg.c7388a22.png";